import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {};

export const ProdutosServicosContext = createContext();

export const ProdutosServicosProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [produtosServicos, setProdutosServicos] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getProdutosServicos = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: produtosServicos?.filter,
        page: produtosServicos?.page,
        size: produtosServicos?.size,
        order: produtosServicos?.order,
        ...payload,
      });
      setProdutosServicos((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <ProdutosServicosContext.Provider
      value={{ getLoading, produtosServicos, getProdutosServicos }}
    >
      {children}
    </ProdutosServicosContext.Provider>
  );
};
